<template>
  <div class="status">
    <div>
      <b>Bestellstatus:</b> <span :class="color || ''">{{ status }}</span>
    </div>
    <div class="status__number">
      <b>Auftragsnummer:</b> <span class="status__number">{{ number }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['status', 'number', 'color'],
};
</script>

<style lang="scss" scoped>
.status {
  display: flex;
  align-items: center;
  > div {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 3.125rem;
    padding: 0.5625rem 1rem;
    font-size: 0.75rem;
    background-color: $gray;
    b {
      margin-right: 0.3125rem;
    }
    span:not(.status__number) {
      font-weight: 700;
      color: $darkgray;
      &.red {
        color: $red;
      }
      &.orange {
        color: $red;
      }
    }
    &.status__number {
      b, span {
        text-align: right;
      }
    }
  }
  &__number {
    font-size: 0.75rem;
  }
  @include breakpoint(tablet) {
    display: none;
  }
}
</style>
